import React from 'react';
import { DownloadAppBanner } from 'shared/components/ui/download-app-banner';
import { OnboardingProvider } from 'shared/contexts/onboarding';
import { useDownloadAppPlatformQuery } from 'shared/hooks/queries/use-download-app-platform-query';

export type DownloadAppGateProps = {
  children: React.ReactNode;
};

export const DownloadAppGate: React.FC<DownloadAppGateProps> = ({
  children,
}) => {
  const { data: platform } = useDownloadAppPlatformQuery();

  if (!platform) {
    return children;
  }

  return (
    <OnboardingProvider>
      <DownloadAppBanner platform={platform} />
    </OnboardingProvider>
  );
};
